import { jwtDecode } from "jwt-decode";
import api from "./api";

// Function to fetch sentences from the server
export const fetchSentencesFromApi = async (params) => {
  try {
    const response = await api.get(`/polyglot/sentences`, { params });
    const sentencesCondensed = response.data;
    sentencesCondensed.sentences = Object.values(
      jwtDecode(sentencesCondensed.sentences)
    )
      .filter((item) => typeof item === "object")
      .flat();
    return sentencesCondensed;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
